import React from 'react';
import classes from "./DataTop.module.css";
const DataTable = ({ data }) => {

  
    
    return (
      <table className={classes.table}>
        <tbody>
          <tr>
            
            <th >US States</th>
            <th >Total Credits</th>
          </tr>
          {data && data.slice(0,10).map((item) => (
            <tr key={item.state}>
              
              <td data-label="Project Type">{item.state}</td>
              <td data-label="Project Name">{item.totalcreditsissued.toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  
  export default DataTable;